export const mutations = {
  setCurrentUser (state, val) {
    state.currentUser = val
  },
  setUserProfile (state, val) {
    state.userProfile = val
  },
  setProfessionalProfile (state, val) {
    if (val) {
      const profile = val
      state.professionalProfile =
        {
          title: profile.title || '',
          email: profile.email || '',
          phoneNumber1: profile.phoneNumber1 || '',
          phoneNumber2: profile.phoneNumber2 || '',
          specialties: profile.specialties || [],
          insurances: profile.insurances || [],
          discount: profile.discount || 0,
          biography: profile.biography || '',
          services: {
            online: (profile.services && profile.services.online) || false,
            inPerson: (profile.services && profile.services.inPerson) || false
          },
          address: {
            street: (profile.address && profile.address.street) || '',
            number: (profile.address && profile.address.number) || '',
            comp: (profile.address && profile.address.comp) || '',
            neighborhood: (profile.address && profile.address.neighborhood) || '',
            city: (profile.address && profile.address.city) || '',
            state: (profile.address && profile.address.state) || ''
          },
          socialNetworks: {
            instagram: (profile.socialNetworks && profile.socialNetworks.instagram) || '',
            facebook: (profile.socialNetworks && profile.socialNetworks.facebook) || '',
            linkedin: (profile.socialNetworks && profile.socialNetworks.linkedin) || '',
            twitter: (profile.socialNetworks && profile.socialNetworks.twitter) || ''
          }
        }
    }
  },
  setSpecialties (state, val) {
    if (!state.specialties.some(specialty => specialty === val.name)) {
      state.specialties.push(val.name)
    }
  },
  setPosts (state, val) {
    state.posts = val
  },
  setUsers (state, val) {
    state.users = val
  },
  setPerformingRequest (state, val) {
    state.performingRequest = val
  },
  setHiddenPosts (state, val) {
    if (val) {
      if (!state.hiddenPosts.some(post => post.id === val.id)) {
        state.hiddenPosts.unshift(val)
      }
    } else {
      state.hiddenPosts = []
    }
  },
  setActiveDashboardSection (state, val) {
    val && (state.activeDashboardSection = val)
  },
  setAdmin (state, val) {
    if (typeof val !== 'undefined' && val !== null) {
      state.isAdmin = val
    }
  },
  setPremium (state, val) {
    if (typeof val !== 'undefined' && val !== null) {
      state.isPremium = val
    }
  },
  setPlan (state, val) {
    if (typeof val !== 'undefined' && val !== null) {
      state.plan = val
    }
  },
  setCurrentUserFavorites (state, val) {
    if (val) {
      state.currentUserFavorites = val
    }
  },
  addToCurrentUserFavorites (state, val) {
    if (val) {
      state.currentUserFavorites.push(val)
    }
  },
  removeFromCurrentUserFavorites (state, val) {
    if (val) {
      state.currentUserFavorites = state.currentUserFavorites.filter(favorite => {
        return favorite.userId !== val
      })
    }
  },
  setLocationName (state, val) {
    if (val) {
      state.locationName = val
    }
  },
  setCoordinates (state, val) {
    if (val) {
      state.coordinates = val
    }
  },
  setPlans (state, val) {
    if (val) {
      state.plans = val
    }
  }
}

export default mutations
